import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { API_URL, TOKEN } from "../../../variables/constants";
import { toast } from "react-toastify";

const AddProfession = ({ show, handleClose, editMode, selectedProfession, onAdd, professions = [] }) => {
  const [loading, setLoading] = useState(false);
  const [nom, setNom] = useState("");

  useEffect(() => {
    if (editMode && selectedProfession) {
      setNom(selectedProfession.libelleParametre || "");
    } else {
      setNom("");
    }
  }, [editMode, selectedProfession]);

  const onSubmit = async (e) => {
    e.preventDefault();

    const trimmedNom = nom.trim().toLowerCase();

    const isDuplicate = professions.some(
      (p) =>
        p.libelleParametre.trim().toLowerCase() === trimmedNom &&
        (!editMode || p.parametreId !== selectedProfession?.parametreId)
    );

    if (isDuplicate) {
      toast.warning("Cette profession existe déjà.");
      return;
    }

    setLoading(true);

    const professionData = {
      ...selectedProfession,
      libelleParametre: nom,
      typeParametre: "PROFESSION",
    };

    const request = editMode
      ? axios.put(`${API_URL}/api/parametre`, professionData, {
          headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        })
      : axios.post(`${API_URL}/api/parametre`, professionData, {
          headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        });

    try {
      const res = await request;
      const newData = res.data;

      toast.success(editMode ? "Profession modifiée avec succès" : "Profession ajoutée avec succès");

      if (!editMode && onAdd) {
        onAdd(newData); // Ajouter la nouvelle profession en haut de la liste
      }

      handleClose();
    } catch (err) {
      console.error("Erreur :", err);
      toast.error(editMode ? "Erreur lors de la modification" : "Erreur lors de l'ajout");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Body>
        <button
          type="button"
          className="btn-close btn-primary"
          onClick={handleClose}
          aria-label="Close"
        ></button>
        <div className="text-center mb-4">
          <h4 className="address-title mb-2">
            {editMode ? "Modifier la" : "Ajouter une"} profession
          </h4>
          <p className="address-subtitle">
            {editMode ? "Modifier la" : "Ajouter une nouvelle"} profession
          </p>
        </div>
        <form className="row g-3" onSubmit={onSubmit}>
          <div className="col-12">
            <label className="form-label" htmlFor="modalAddressFirstName">
              Nom
            </label>
            <input
              type="text"
              id="modalAddressFirstName"
              onChange={(e) => setNom(e.target.value)}
              className="form-control"
              placeholder="Nom de la profession"
              value={nom}
              required
            />
          </div>
          <div className="col-12 text-center">
            <button
              type="submit"
              className="btn btn-primary me-3"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-grow spinner-grow-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Enregistrement...
                </>
              ) : (
                "Enregistrer"
              )}
            </button>
            <button
              type="reset"
              className="btn btn-label-secondary"
              onClick={handleClose}
            >
              Annuler
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddProfession;
